import forEach from 'lodash/forEach';

export default function (selectedProducts, parameterGroups, t) {
    const DEFAULT_LOCALE = 'en_US';
    const SUPPORTED_LOCALES = ['en_US', 'zh_CN', 'ja_JP', 'ko_KR', 'de_DE'];

    let currentLocale = window.Liferay.ThemeDisplay.getLanguageId();

    if (!SUPPORTED_LOCALES.includes(currentLocale)) {
        currentLocale = DEFAULT_LOCALE;
    }

    const getParamValues = (parameterMetaData, parameters) => {
        if (parameterMetaData && parameters && parameters.length) {
            const index = parameters.findIndex(x => x.id === parameterMetaData.id);
            const parameter = index === -1 ? null : parameters[index];
            if (parameter?.values?.length) {
                const unit = parameter.unit ? ' ' + parameter.unit : '';
                return parameter.values.map(value => value + unit).join(', ');
            }
        }
        return '';
    };

    const csvData = [];
    const headerRow = [
        t('search_deviceName'),
        t('search_productFamily'),
        t('search_productArea'),
        t('search_productType'),
        t('search.compareViewApplicationType'),
        t('search.subApplicationType'),
    ];

    forEach(parameterGroups, group => {
        forEach(group.data, parameter => {
            headerRow.push(parameter.name + ' ' + parameter.prefix);
        });
    });

    csvData.push(headerRow);

    forEach(selectedProducts, product => {
        const row = [product.name, product.familyHeadline, product.productType1, product.productType2];

        let firstLevelApps = [];
        let subLevelApps = [];

        forEach(product.applications, application => {
            let applicationTitle = application.titleMap[currentLocale] || '';

            if (application.parentId === 0) {
                firstLevelApps.push(applicationTitle);
            } else {
                subLevelApps.push(applicationTitle);
            }
        });

        row.push(firstLevelApps.join(', '));
        row.push(subLevelApps.join(', '));

        forEach(parameterGroups, group => {
            forEach(group.data, parameter => {
                row.push(getParamValues(parameter, product.parameters));
            });
        });

        csvData.push(row);
    });

    let csvContent = '';
    forEach(csvData, row => {
        csvContent += row.join(';') + '\n';
    });

    const utf8bom = '%EF%BB%BF';
    const anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + utf8bom + encodeURIComponent(csvContent);
    anchor.target = '_blank';
    anchor.download = 'products.csv';
    anchor.click();
}
